export default __webpack_public_path__ + "models/f7c0052798da09055742609ce320e8cd.glb";